<template>
  <v-dialog v-model="dialogDelete" max-width="500px">
    <DeleteCard
      title="Doriți să ștergeți această cerere de modificare note cu toate înregistrările?"
      @cancel="cancelDelete"
      @confirm="confirmDelete"
    />
  </v-dialog>
</template>

<script>
import DeleteCard from "@/components/elements/DeleteCard.vue";
import * as api from "./api.js";

export default {
  props: {
    request: Object,
    visible: Boolean
  },
  components: {
    DeleteCard,
  },
  data() {
    return {
      dialogDelete: false,
    };
  },
  watch: {
    visible(newValue) {
      this.dialogDelete = newValue;
    }
  },
  methods: {
    show() {
      this.dialogDelete = true;
    },
    cancelDelete() {
      this.dialogDelete = false;
    },    async confirmDelete() {
      // Check for multiple possible ID field names
      const requestId = this.request?.requestId || this.request?.id;
      
      if (!this.request || !requestId) {
        this.$emit("error", "Nu se poate șterge cererea: ID lipsă");
        this.dialogDelete = false;
        return;
      }
      
      try {
        await api.deleteTeacherRequest(requestId);
        this.$emit("updateRequestData");
        this.$emit("success", "Cererea a fost ștearsă cu succes");
        this.dialogDelete = false;
      } catch (error) {
        console.error("Error deleting request:", error);
        this.$emit("error", "A apărut o eroare la ștergerea cererii");
      }
    },
  },
};
</script>
